<template>
    <div v-if="coopList.length" >
        <h3 class="columnTit" ><span>合作媒体·机构</span></h3>
        <div class="friendList data_recommend" data-recommend-id="5c00d2dda0ef2f011d6476ef">
            <template v-for="(item,i) in coopList">
                <a target="_blank" :key="i" :href="item.link">{{item.title}}</a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props:['coopList'],
    name: "IndexCoop"
}
</script>

<style scoped lang="scss">
/*合作媒体*/
.friendList{font-size: 12px;line-height: 20px;border:1px solid #D9D9D9;background-color: #FAFAFA;text-align: center;padding:20px;
    a{display:inline-block;padding:0 20px;position: relative;
        &:after{content:'';position: absolute;top:4px;width:1px;height:14px;right:0;background-color: #F2F2F2;display:block;}
    }
}
</style>